import React from 'react';
import { useForm } from 'react-hook-form';
import FormWrapper from '../../../../Components/Form/FormWrapper';
import TextAreaField from '../../../../Components/Form/components/TextAreaField';
import SubmitButton from '../../../../Components/Button/SubmitButton';
import InputWrapper from '../../../../Components/Form/components/InputWrapper/InputWrapper';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
// @ts-ignore
import styles from './ActionCenterReplyForm.module.scss';
import apiClient from '../../../../Services/ApiClient';
import useApiClient from '../../../Base/Hooks/useApiClient';
import { FormValues } from '../../../MagicForm/Interfaces/FormValues';
import useNotification from '../../../../Hooks/useNotification.hook';
import useTranslation from '../../../../Hooks/useTranslation';

interface Props {
	onCancel: () => void;
	onSuccess: () => void;
	conversationId: string;
	lastMessageId: string;
	respondToAll: boolean;
}

const validationScheme = yup.object({
	content: yup.string().required(),
});

const ActionCenterReplyForm: React.FC<Props> = ({
	onCancel,
	conversationId,
	lastMessageId,
	onSuccess,
	respondToAll,
}) => {
	const formMethods = useForm({ resolver: yupResolver(validationScheme) });
	const { displayError } = useApiClient();
	const { showNotificationSuccess } = useNotification();
	const { t } = useTranslation();

	const handleReply = async (values: FormValues) => {
		try {
			const createdMessage = await apiClient.post(
				`/conversation/${conversationId}/message`,
				{
					content: {
						text: values?.content,
					},
					type: 'TEXT',
					respondToAll,
					messageId: lastMessageId,
				},
			);
			if (createdMessage.status === 200) {
				showNotificationSuccess({ content: t('base.messageSent') });
				onSuccess();
			}
		} catch (e) {
			displayError(e);
		}
	};

	return (
		<FormWrapper formMethods={formMethods}>
			<InputWrapper>
				<TextAreaField name='content' />
			</InputWrapper>
			<div className={styles.buttonsWrapper}>
				<SubmitButton onSubmit={handleReply} title='base.shared.form.send' />
				<LinkButton
					title='base.shared.cancel'
					theme={Theme.RED}
					onClick={onCancel}
				/>
			</div>
		</FormWrapper>
	);
};

export default ActionCenterReplyForm;
